import styled from "styled-components";
import { Button } from "../../../Components/Button";

export const Wrapper = styled.div`
  height: auto;
  margin-bottom: 4rem;
  max-height: 70vh;
  overflow-y: auto;
`;

export const CircleIconButton = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: bold;
  color: ${({ isAdd }) => (isAdd ? "var(--primary-blue)" : "var(--primary-blue-300)")};
  background-color: var(--primary-dark-50);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: var(--primary-dark-100);
    color: var(primary-dark-50);
  }
`;

export const AddButton = styled(CircleIconButton)`
  margin-right: auto;
`;

export const SaveButton = styled(Button)`
  margin-left: auto;
  margin-top: 2rem;
`;

export const EmailContainer = styled.div`
  width: 100%;
`;

export const EmailCard = styled.div`
  background: #f7f8fa;
  border: 1px solid #e3e6ee;
  border-radius: 10px;
  padding: 18px 10px 10px;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e3e6ee;
  margin: 1.5rem 0;
`;

export const EmailFields = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const EmailInputWrapper = styled.div`
  flex: 1;
`;

export const Spacer = styled.div`
  height: 1.5rem;
`;

export const RightControls = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 1rem;
`;

export const AddButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 0.5rem;
`;
